import React, { useEffect } from 'react';
import { Navbar, Footer } from '../components';
import './TermsPage.css';

const TermsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="terms-page">
            <Navbar />
            <main className="terms-content">
                <div className="terms-container">
                    <h1>Terms of Service</h1>
                    <p>Please review our terms of service. By using SayAgain, you agree to these terms.</p>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default TermsPage;
